import './AppIcon.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var icon = _7a468({defaultClassName:'_1y72i761-2-0-1',variantClassNames:{fadeIn:{true:'_1y72i762-2-0-1'}},defaultVariants:{},compoundVariants:[]});